import VTooltip from 'v-tooltip';
import { Logger, Vue, sessionManager } from 'vue-infra';
import routes from './router/routes';
import { appCode, appName } from '../config';
import { loadI18nResources } from './i18n/resource-resolver';
import './styles/app.scss';


const logger = Logger.getLogger('main.js');
/* eslint-disable global-require */
const AppComponent = r => require.ensure([], () => r(require('./App.vue')), 'AppComponent');
/* eslint-enable global-require */

// fixme - add instructions for every prop
const config = {

  id: appName,

  keepDOMRendered: false, // true -> use v-show instead of v-if in the application renderer

  moduleName: appName,

  routePrefix: appCode,

  // todo - don't just pass any persona
  personaMapping: appName,

  // todo - try passing ['*']
  personas: ['agent', 'agentManager', 'admin', appName],

  switcher: {

    // fixme (LE) - provide fallback in case this is not set
    control: `switcher-item-${appCode}`,

    fontIconName: 'ico-ihub', // icon for the navigation menu.

    // fontIconName: 'ico-<something>', // icon for the navigation menu.

    // fixme (LE) - provide fallback in case this is not set
    index: 999999,
    // todo - try these
    title: appName,
    tooltip: appName,
    titleTranslationKey: 'general.title',
    tooltipTranslationKey: 'general.title',
  },

  // @deprecated - will be removed in LE 10.9
  external: true,
  // @deprecated - will be removed in LE 10.9
  regionId: `${appName}-external`,
  // @deprecated - will be removed in LE 10.9
  container: 'work-area-wrapper',
  // @deprecated - will be removed in LE 10.9
  template: 'workAreaItemNoLEClass',
};

const canInitialize = () => {
  if (
    sessionManager.getFeatureProperty('LEUI.iHub_Enabled') &&
    !sessionManager.getFeaturePropertyState('LEUI.iHub_Enabled')
  ) {
    return false;
  }

  const accountZone = sessionManager.getAccountZone();
  const plugin = document.createElement('script');
  if (accountZone === 'z2') {
    plugin.setAttribute(
      'src',
      'https://embedding.workato.com/r/embedding-client-eu.js',
    );
  } else {
    plugin.setAttribute(
      'src',
      'https://embedding.workato.com/r/embedding-client.js',
    );
  }
  // plugin.async = true;
  document.head.appendChild(plugin);
  const isAdmin = sessionManager.isAdmin();
  const isLPA = sessionManager.isLPA();

  return isAdmin || isLPA;
};

const registerAppComponent = () => {
  // register the component globally to get the Vue.js dev-tools working.
  // the registration name must be the same as config.routePrefix, in order for the component to load property.
  Vue.component(appCode, {
    name: 'main',
    components: {
      App: AppComponent,
    },
    template: '<App/>',
  });
  Vue.use(VTooltip);
};

const applicationInit = async (leAppConfig) => {
  if (!canInitialize(leAppConfig)) {
    return {};
  }
  const i18nResources = await loadI18nResources(leAppConfig.locale, leAppConfig.fallbackLocale);
  const store = new Vue().$store;
  const isLpa = store.getters['session/getConfig']().isLPA;
  const accountId = store.getters['session/getValue']('accountId');
  const userId = store.getters['session/getValue']('userId');
  logger.info('accountId', 'userId', 'lpa', {
    accountId, userId, isLpa,
  });

  registerAppComponent();

  return {
    appId: appCode,
    routes,
    ...i18nResources,
  };
};

const webpackPathInit = (leAppConfig) => {
/* eslint-disable no-undef */
/* eslint-disable camelcase */
  __webpack_public_path__ = leAppConfig.publicPath;
/* eslint-enable no-undef */
/* eslint-enable camelcase */
};


export default {
  config,
  // todo - rename to 'initialize'
  applicationInit,
  // todo - rename as lifecycle hook: 'on[Something]', i.e. according to the invoked LE lifecycle event.
  // todo - suggestions: onBootstrap, onAppsLoad
  webpackPathInit,
};
